import { render, staticRenderFns } from "./themeMobile.vue?vue&type=template&id=2ed1efd4&scoped=true"
import script from "./themeMobile.vue?vue&type=script&lang=js"
export * from "./themeMobile.vue?vue&type=script&lang=js"
import style0 from "./themeMobile.vue?vue&type=style&index=0&id=2ed1efd4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed1efd4",
  null
  
)

export default component.exports